import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import ataricLogo from "../assets/ataric-logo.png";

const BlogHeader = () => {
  return (
    <header className="sticky top-0 z-50 border-b border-border/50 bg-background/70 backdrop-blur-2xl">
      <div className="container mx-auto flex items-center justify-between px-4 py-4 max-w-5xl">
        <Link to="/blog" className="flex items-center gap-2.5 group">
          <img src={ataricLogo} alt="Ataric" className="h-20 w-auto" />
          <div className="h-5 w-px bg-border" />
          <span className="text-xs text-muted-foreground font-medium tracking-[0.25em] uppercase">Blog</span>
        </Link>
        <nav className="flex items-center gap-5">
          <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300">
            Artigos
          </Link>
          <a
            href="https://www.ataric.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="group/btn inline-flex items-center gap-1.5 text-sm font-semibold text-primary-foreground bg-primary/90 hover:bg-primary px-4 py-2 rounded-full transition-all duration-300 hover:shadow-[0_0_20px_-3px_hsl(270_70%_55%/0.6)]"
          >
            <Sparkles className="h-3.5 w-3.5" />
            Experimentar App
          </a>
        </nav>
      </div>
    </header>
  );
};

export default BlogHeader;
